import axios from "axios";
import { baseURL } from "./Constants";

const refreshToken = async () => {
  try {
    const token = localStorage.getItem("@userCsc");
    const axiosInstance = axios.create({
      baseURL: baseURL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const response = await axiosInstance.post("/refresh-token");
    const newToken = response.data.token;
    localStorage.setItem("@userCsc", newToken);
    return newToken;
  } catch (error) {
    localStorage.removeItem("@userCsc");
    window.location.href = "/login";
  }
};

const getAxiosInstance = () => {
  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Add a response interceptor to retry the request
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const { config, response } = error;
      if (response) {
        config.__retryCount = config.__retryCount || 0;
        if (config.__retryCount >= 3) {
          return Promise.reject(error);
        }
        config.__retryCount += 1;
        const delay = config.__retryCount * 1000;
        if (response.status === 401) {
          console.log("refresh token");
          const token = await refreshToken();
          config.headers["Authorization"] = `Bearer ${token}`;
          return new Promise((resolve) =>
            setTimeout(() => resolve(instance(config)), delay)
          );
        } else {
          return new Promise((resolve) =>
            setTimeout(() => resolve(instance(config)), delay)
          );
        }
      } else {
        return Promise.reject(error);
      }
    }
  );
  return instance;
};

const axiosClient = getAxiosInstance();

export default axiosClient;
